import { useNVKEventSubscribe, NavigateParams, getCorrectedURLSearchParams } from '@novakid/frontend-core';
import { useCallback } from 'react';

import { router } from 'router';

export const useAppNavigation = () => {
  const onNavigate = useCallback((pathOrOptions: NavigateParams) => {
    const searchParams = getCorrectedURLSearchParams(router.state.location.search);

    if (searchParams.has('isLogging')) {
      console.log('useAppNavigation callback argument ->', pathOrOptions);
      console.log('useAppNavigation callback current search ->', searchParams.toString());
    }

    if (typeof pathOrOptions === 'string') {
      router.navigate({
        search: searchParams.toString(),
        pathname: pathOrOptions,
      });

      return;
    }

    if (typeof pathOrOptions.search === 'undefined') {
      const { additionalParams, extraParams } = pathOrOptions;

      if (additionalParams) {
        Object.entries(additionalParams).forEach((entry) => {
          searchParams.set(entry[0], entry[1].toString());
        });
      }

      if (extraParams) {
        extraParams.forEach((paramName) => {
          searchParams.delete(paramName);
        });
      }

      router.navigate({
        pathname: pathOrOptions.pathname,
        search: searchParams.toString(),
      });

      return;
    }

    const { search } = pathOrOptions;
    const withoutSearch = search === false || search === '';

    router.navigate({
      search: withoutSearch ? '' : search,
      pathname: pathOrOptions.pathname,
    });
  }, []);

  useNVKEventSubscribe('NVK_NAVIGATE', onNavigate);
};